// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__1RFRA","errors":"Errors_errors__26XPK"};